module.exports = __webpack_public_path__ + "img/wallet.1cbac0e4.svg";